import { useNavigation } from "../../../hooks/useNavigation";

export interface StakeholderNavigateProps {
  project_id: number;
  object_type: string;
  object_id: number;
  description: string;
  portfolio_name: string;
  programme_name: string;
  project_name: string;
}

export const useStakeholderRedirection = () => {

    const { goToProjectTaskDetails, goToSchedulePlanning, goToProjectArtefacts } = useNavigation();

    const handleStakeholderRedirection  = (task: StakeholderNavigateProps) => {
        switch (task.object_type) {
            case "task":
            goToProjectTaskDetails({
                projectId: task.project_id,
                projectName: task.project_name,
                taskId: task.object_id
            })
            break;
            case "phase":
                goToSchedulePlanning({
                    projectId: task.project_id,
                    projectName: task.project_name,
                    objectId: task.object_id,
                    type: task.object_type
                })
            break;
            case "artefact":
                goToProjectArtefacts({
                    projectId: task.project_id,
                    projectName: task.project_name,
                    artefactId: String(task.object_id)
                })
        }
    }

    return {
        handleStakeholderRedirection
    }
};